import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.css'],
})
export class ActionButtonComponent {
  @Input() text = '';
  @Input() icon = '';
  @Input() title = '';
  @Input() shortcut = '';
  @Input() variant: 'primary' | 'secondary' | 'light' | 'dark' = 'primary';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() routerLink: string | any[] = '';
  @Input() ariaLabel = '';
  @Input() disabled = false;

  @Output('action')
  action = new EventEmitter<MouseEvent>();

  handleClick(event: MouseEvent): void {
    if (this.disabled) {
      return;
    }

    this.action.emit(event);
  }
}
